'use client'

import * as styles from './Tooltip.css'
import {
  TooltipAnchor,
  TooltipProvider,
  Tooltip as TooltipContentBase,
  type TooltipProps,
  type TooltipAnchorProps,
  type TooltipProviderProps,
} from '@ariakit/react'

export function Tooltip({
  children,
  placement = 'bottom',
  timeout = 300,
  ...props
}: TooltipProviderProps) {
  return (
    <TooltipProvider placement={placement} timeout={timeout} {...props}>
      {children}
    </TooltipProvider>
  )
}

export function TooltipContent({
  children,
  unmountOnHide = true,
  align = 'center',
  ...props
}: TooltipProps & {
  /**
   * `start` for tooltips carrying more than one line of content, where
   * centering makes the lines hard to scan.
   */
  align?: 'center' | 'start'
}) {
  return (
    <TooltipContentBase
      gutter={6}
      unmountOnHide={unmountOnHide}
      {...props}
      className={`${styles.tooltipContent} ${styles.align[align]}`}
    >
      {children}
    </TooltipContentBase>
  )
}

export function TooltipTrigger({ children, ...props }: TooltipAnchorProps) {
  return <TooltipAnchor {...props}>{children}</TooltipAnchor>
}
